import { AutoRenewalIneligibilityReason } from '../components/auto-renew-eligibility-content';

type AutoRenewalStatus = 'ineligible' | 'eligible';
type AutoRenewalEligibility = {
	status: AutoRenewalStatus;
	reason: AutoRenewalIneligibilityReason;
};

export const getAutoRenewalEligibility = (
	isActiveProtectYoungDriver: boolean,
	isEndOfProduct: boolean,
): AutoRenewalEligibility => {
	const eligibility: AutoRenewalEligibility = {
		status: 'eligible',
		reason: '',
	};

	if (isActiveProtectYoungDriver) {
		eligibility.status = 'ineligible';
		eligibility.reason = 'young-driver';
	}
	if (isEndOfProduct) {
		eligibility.status = 'ineligible';
		eligibility.reason = 'end-of-product';
	}
	return eligibility;
};
